module.exports = __webpack_public_path__ + "static/scale-model-of-chattahoochee-nature-center-in-sandy-springs-georgia-b5c2236e8a6b5d5da57c9cc48537a39f.png";